<template>
	<div class="content">

		<loading v-if="!loaded"/>
		<div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានអំពីរំលោះ #{{loan.hash}}</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100 text-right">
					<span class="late">* តម្រូវបំពេញ</span>
				</div>
				<div class="md-layout">
					<div class="md-layout-item md-small-size-100 md-size-50">
						<label>ទីតាំងគម្រោង *</label>
						<v-select label="name" inputId="id" :clearable="false" :options="projectList" v-model="loan.projectArray">
						</v-select>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-50">
						<md-field>
							<label>លេខឡូតិ៍ *</label>
							<md-input type="text" v-model="loan.lot"></md-input>
						</md-field>
					</div>

					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-field>
							<label>កំណត់ចំណាំ</label>
							<md-input type="text" v-model="loan.note"></md-input>
						</md-field>
					</div>
				</div>

				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>អតិថិជន</h3>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-70 md-size-70">
							<md-field>
								<label>ស្វែងរកអតិថិជនដោយឈ្មោះ លេខទូរស័ព្ទ ឬ លេខកូដ</label>
								<md-input type="text" v-model="search.text" @keyup.enter="searchClient()">
								</md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-30 md-size-30">
							<md-button class="md-raised md-primary" @click="searchClient()" style="width: 100%">ស្វែងរក
							</md-button>
						</div>
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-table>
								<md-table-row v-for="(client, index) in search.clientList.slice(0, 5)">
									<md-table-cell>
										<!-- <img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px"> -->
										<b>ID: {{client.hash}}</b> ({{client.name}}, {{client.phone}})
									</md-table-cell>
									<md-table-cell class=" text-right">
										<md-button class="md-just-icon md-simple md-success" @click="addClient(client)">
											<md-icon>add</md-icon>
											<md-tooltip md-direction="top">ភ្ជាប់អតិថិជននេះ</md-tooltip>
										</md-button>
									</md-table-cell>
								</md-table-row>
							</md-table>
						</div>
					</div>
				</div>

			</div>
			<div class="md-layout-item md-small-size-100 md-size-50">
				<div class="md-layout-item md-small-size-100 md-size-100">
					<h3>ព័ត៌មានសង្ខេប</h3>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-100">
					<md-table>

						<md-table-row>
							<md-table-cell style="width: 40%;">អតិថិជន</md-table-cell>
							<md-table-cell style="width: 5px">:</md-table-cell>
							<md-table-cell>

								<span v-if="String(loan.client_id).length > 0"
									style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
									<span><b>ID: {{loan.client[0].hash}}</b> ({{loan.client[0].name}})</span>
									<md-button class="md-just-icon md-simple md-danger" @click="removeClient()">
										<md-icon>remove</md-icon>
										<md-tooltip md-direction="top">លុបចេញ</md-tooltip>
									</md-button>
								</span>
								<span v-else>មិនទាន់មាន</span>

							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>ទីតាំងគម្រោង</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(loan.project).length > 0">{{loan.project}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>លេខឡូតិ៍</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(loan.lot).length > 0">{{loan.lot}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
						<md-table-row>
							<md-table-cell>កំណត់ចំណាំ</md-table-cell>
							<md-table-cell>:</md-table-cell>
							<md-table-cell>
								<span v-if="String(loan.note).length > 0">{{loan.note}}</span>
								<span v-else>មិនទាន់មាន</span>
							</md-table-cell>
						</md-table-row>
					</md-table>
				</div>
			</div>
			<div class="md-layout-item md-size-100 text-right">
				<md-button class="md-raised md-primary" @click="updateLoan()">កែប្រែ</md-button>
			</div>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	export default {
		components: { Datetime },
		created() {

			this.getLoan();
			this.searchProject();
		},

		data() {
			return {
				loaded: false,
				loadMore: false,
				deleteDialogActive: false,
				deleteSelected: '',
				search: {
					clientList: [],
					type: "",
					text: "",
					status: ""
				},
				loan: {
					hash: "",
					lot: "",
					note: "",
					client_id: "",
					project: "",
					project_id: "",
					projectArray: "",
					client: [],
				},
				projectList: []

			}
		},
		watch: {
			'loan.projectArray': function (val) {
				if (String(this.loan.projectArray).length > 5) {
					this.loan.project_id = this.loan.projectArray.id;
					this.loan.project = this.loan.projectArray.name;
				} else {
					this.loan.project_id = "";
					this.loan.project = "";
				}
			},
		},
		methods: {
			getLoan(offset = 0, replace = true) {
				this.$http.get(this.config.api + "/admin/loan/get/" + this.$route.params.hash).then(data => {

					this.loan.hash = data.body.data.hash;
					this.loan.lot = data.body.data.lot;
					this.loan.note = data.body.data.note;

					this.loan.client_id = data.body.data.client_id;
					this.loan.client.push({hash: data.body.data.client_hash, name: data.body.data.client_name});

					this.loan.project_id = data.body.data.project_id;
					this.loan.project = data.body.data.project_name;
					this.loan.projectArray = {id: data.body.data.project_id, name: data.body.data.project_name};

					this.loaded = true;
				})
			},
			updateLoan() {
				if (String(this.loan.amount).length > 0 && String(this.loan.interest).length > 0 && String(this.loan.term).length > 0) {
					this.loan.start_date = (new Date(this.loan.start_date_prototype)).getTime();
					this.$http.post(this.config.api + "/admin/loan/update", {
						loan: this.loan,
					}).then(data => {
						if (data.body.status == 'success') {
							this.$notification.notify({
								message: "រំលោះត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							});
							this.$router.push("/loans/detail/" + data.body.data.hash);
						}
					})
				} else {
					this.$notification.notify({
							message: "សូមបំពេញព័ត៌មានអោយបានត្រឹមត្រូវ",
							icon: 'error',
							type: 'danger'
					})
				}
			},
			searchProject() {
				this.$http.post(this.config.api + "/admin/project/search", {
					text: ""
				}).then(data => {
					this.projectList = data.body.data;
					this.loaded = true;
				})
			},
			searchClient() {
				this.$http.post(this.config.api + "/admin/client/search", {
					text: this.search.text,
					gender: ""
				}).then(data => {
					this.search.text = "";
					// this.loadMoreCompanyButton = true
					this.search.clientList = data.body.data;
				})
			},
			addClient(client) {
				this.loan.client_id = client.id;
				this.loan.client.push(client);
				this.search.clientList = []
			},
			removeClient() {
				this.loan.client_id = "";
				this.loan.client = [];
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/EditPayment.vue